module.exports = require('happened').create({
    scheduler: setImmediate
});
